import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectLeadsQueryItems } from '../../../../../../redux/leads/selector';
import { leads } from '../../../../../../redux/leads/action';
import PageLoader from '../../../../../../components/PageLoader';
import LeadComponent from '../components/lead.component';

const CustomerLead = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const leadQuery = useSelector(selectLeadsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    leadDetails,
    setLeadDetails
  ] = useState<any>([])


  const fetchLeadById = () => {
    dispatch(leads.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/leads/query`, entity: 'leads', jsonData: {

        Records: [

          { Id: parmas?.id }

        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }


  useEffect(
    () => {

      if (parmas?.id > 0) {
        fetchLeadById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    },
    []
  )

  useEffect(
    () => {

      if (isQuery) {
        setLeadDetails(leadQuery?.result?.items)
      }
    },
    [isQuery]
  )


  const back = () => {
    navigate('/customer/sales/leads')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <LeadComponent
          leadDetails={leadDetails}
          back={back}
        />}
    </>
  )

}

export default CustomerLead;